/* eslint eqeqeq: 0 */
import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from "@fortawesome/free-regular-svg-icons";
import { faTrashArrowUp } from "@fortawesome/free-solid-svg-icons";
import axios from 'axios';
import DataTable from 'react-data-table-component';
import Pengaturan from './components/pengaturan';
function Pppsecret(){
    //username (secret), profile baru, nominal, id_konsumen, id_bank
    const formData = new FormData();
    const dataHapus = new FormData();
    const [id, setId] = useState('');
    const [pass, setPass]=useState('');
    const [secretName, setSecretName]=useState('');
    const [comment, setComment]=useState('');
    const [callerId, setCallerId]=useState('');
    const [servis, setServis]=useState('');
    const [judulModal, setJudulModal]=useState('');
    const [show, setShow]=useState(false);
    const [showError, setShowError]=useState(false);
    const [judulError, setJudulError]=useState('');
    const [btnError, setBtnError]=useState('');
    const [loading, setLoading] = useState(false);
    const [pilihProfile, setPilihProfile]=useState('');
    const [profile, setProfile]=useState('');
    const [pesanError, setPesanError]=useState('');
    const [search, setSearch]=useState('');
    const [diCari, setDiCari]=useState('');
    const [posts, setPosts] = useState([]);
    const handleClose=()=>setShow(false);
    const handleShow=()=>setShow(true);
    const errorShow=()=>setShowError(true);    
    const errorClose=()=>setShowError(false);
    let pesan_error=[];
    const myNewTheme= {
        rows: {
          fontSize: '150px'
        }
      }
    const columns = [
        {
            name: 'User Name',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Password',
            selector: row => row.password,
            sortable: true,
        },
        {
            name: 'Profile',
            selector: row => row.profile,
            sortable: true,
        },
        {
            name: 'Comment',
            selector: row => row.comment,
            sortable: true,
        },
        {
            cell: (row) => <span style={{fontSize:18}}>
                            <span style={{cursor:'pointer'}} title="Edit Secret" onClick={()=>showForm('edit',row)}>&nbsp;<FontAwesomeIcon icon={faPenToSquare} /></span>&nbsp;&nbsp;
                            <span style={{cursor:'pointer'}}onClick={()=>hapus(row)} title="Hapus Secret"><FontAwesomeIcon icon={faTrashArrowUp} /></span>
                            </span>,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];
    const hapus=(r)=>{
        let text_error;
        text_error='Anda akan menghapus Secret<ul><li>Nama Secret : '+r.name+'</li><li>Profile : '+r.profile+'</li></ul>';
        setPesanError(<div dangerouslySetInnerHTML={{"__html": text_error}}></div>);
        setJudulError('Hapus Secret');
        setBtnError(
            <Button variant="danger" onClick={()=>hapuskan(r)}>Hapus</Button>
        )
        errorShow();
        
    }
    const hapuskan=async(row)=>{
        dataHapus.append('id',row.id);
        dataHapus.append('router',localStorage.getItem('rtr'));
        await axios.post(Pengaturan['urlApi']+'secrethapus', dataHapus)
        .then((response)=>{
            errorClose();
            ambilData();
        }); 
    }
    useEffect(()=>{
        ambilData();
    },[search]); 
    const ambilData = async () =>{
        const params = {cari: search,router: localStorage.getItem('rtr')};
        const headers= {"Access-Control-Allow-Origin": "*"} 
        setLoading(true);
        await axios.get(Pengaturan['urlApi']+'getsecret', {params}, {headers},)
        .then((response)=>{
            setPosts(response.data)
        });
        setLoading(false);
    };
    const closeError=()=>{
        pesan_error.length=0;
        setShowError(false);
    }
   
    const simpanSecret=async()=>{
        setShowError(false);
        if(secretName.length < 2) pesan_error.push('Secret Belum diisi'); 
        if(pass.length < 2) pesan_error.push('Password Belum diisi');  
        if(profile.length < 2) pesan_error.push('Profile Belum dipilih'); 
        if(pesan_error.length < 1){
            formData.append('router',localStorage.getItem('rtr'));
            formData.append('profile',profile);
            formData.append('password',pass);
            formData.append('secretname',secretName);
            formData.append('comment',comment);
            formData.append('callerid',callerId);
            formData.append('service',servis);
            formData.append('id',id);
            handleClose();
            setLoading(true);
            await axios.post(Pengaturan['urlApi']+'secretsimpan',formData)
            .then((response) => {
                console.log(response.data);
                if(response.data != '1'){
                    setPesanError(<div dangerouslySetInnerHTML={{"__html": response.data}}></div>);
                    setJudulError('GAGAL menambahkan Secret');
                    setBtnError('');
                    errorShow();
                }else{
                    ambilData();
                }
            });
        }else{
            let text_error='<ul><li>';
            text_error +=pesan_error.join('</li><li>')+'</li></ul>';
            setPesanError(<div dangerouslySetInnerHTML={{"__html": text_error}}></div>);
            setJudulError('ERROR');
            setBtnError('');
            errorShow();
        }
    }
    const showForm=async(act,row=null)=>{
        if(act=='add'){
            setJudulModal('Tambah Secret');
            setProfile('');
            setSecretName('');    
            setComment('');
            setCallerId('');
            setServis('any');
            setPass('');
            setId('');
        }else{
            setId(row.id);
            setJudulModal('Edit Secret');
            setSecretName(row.name);
            setPass(row.password);
            setComment(row.comment);
            setCallerId(row.callerid);
            setServis(row.service);
            setProfile(row.profile);
        }
        let slct;
        handleShow(); 
        if(act=='edit') slct=row.profile; 
        let listProfile;
        let optProfile;
        setPilihProfile(
            <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
            </Spinner>
        );
        await axios.get(Pengaturan['urlApi']+'billinggetprofile?router='+localStorage.getItem('rtr')+'&list=semua')
        .then((response) => {
            listProfile=response.data;
            optProfile = listProfile.map((item,i) => {
                return (
                    <option value={listProfile[i]}>{listProfile[i]}</option>
                )
            }, this);
        });  
        setPilihProfile(
            <select defaultValue={slct} className="form-control" onChange={(event)=>setProfile(event.target.value)}>
                <option value="">Pilih Profile</option>
                {optProfile}
            </select>                
        );                  
    }
    const ubahSecret=(asal)=>{
        setSecretName(asal.replace(/[^\w]/gi, '-').toLowerCase());
    }
    const isi=()=>{
        if(loading){
            return (
                <div className='row justify-content-center'>
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>
            )
        }else{
            return(
            <div className='row justify-content-center'>
                <div className='col-md-12'>
                    <DataTable
                        className='table table-striped'
                        columns={columns}
                        data={posts}
                        pagination
                        customTheme={myNewTheme}
                    />
                </div>
            </div>
            )
        }
    }
    return(
        <>
            <div className='row justify-content-center'>
                <div className="col-md-4">
                    <strong>PPP - Secret</strong>&nbsp;
                </div>
                <div className="col-md-2">
                    
                </div>
                <div className='col-md-6 justify-content-end'>
                <Button variant="primary" onClick={()=>showForm('add')}>Tambah</Button>&nbsp;&nbsp;&nbsp;&nbsp;<input 
                        type='text' 
                        style={{width:'40%'}}
                        placeholder='Cari...' 
                        onChange={(e)=>{
                            if(e.target.value.length > 0){
                                setDiCari(e.target.value);
                            }else{
                                setSearch('');
                            } }} 
                        onKeyDown={(event) => {
                            if (event.key == 'Enter') {
                                setSearch(diCari)
                            }
                          }} />&nbsp;
                    <button className='btn btn-primary btn-sm' onClick={()=>{setSearch(diCari)}}>Cari</button>
                </div>
            </div>
                {isi()}
            <Modal 
                show={showError} 
                onHide={errorClose} 
                backdrop="static" 
                keyboard={false}
                size="lg"
            >
                <Modal.Header closeButton>
                <Modal.Title>{judulError}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {pesanError}
                </Modal.Body>
                <Modal.Footer>
                    {btnError}
                <Button variant="secondary" onClick={closeError}>Close</Button>
                
                </Modal.Footer>
            </Modal>
            <Modal 
                show={show} 
                onHide={handleClose} 
                backdrop="static" 
                keyboard={false}
                size="lg"
            >
                <Modal.Header closeButton>
                <Modal.Title>{judulModal}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Form>
                    <div className="row">
                        <div className="col-md-6">
                        <Form.Group>
                            <Form.Label>Nama Secret</Form.Label>
                            <input placeholder="Secret Name" value={secretName} type="text" className="form-control" onChange={(event)=>ubahSecret(event.target.value)} />
                        </Form.Group>
                        </div>
                        <div className="col-md-6">
                        <Form.Group>
                            <Form.Label>Password</Form.Label>
                            <input placeholder="Password" type="text" value={pass} className="form-control" onChange={(event)=>setPass(event.target.value)} />
                        </Form.Group>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                        <Form.Group>
                            <Form.Label>Pilih Profile</Form.Label>
                            {pilihProfile}
                        </Form.Group>
                        </div>
                        <div className="col-md-6">
                        <Form.Group>
                            <Form.Label>Comment</Form.Label>
                            <input placeholder="Comment" value={comment} type="text" className="form-control" onChange={(event)=>setComment(event.target.value)} />
                        </Form.Group>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                        <Form.Group>
                            <Form.Label>Caller ID</Form.Label>
                            <input placeholder="Caller ID Boleh kosong" type="text" value={callerId} className="form-control" onChange={(event)=>setCallerId(event.target.value)} />
                        </Form.Group>
                        </div>
                        <div className="col-md-6">
                        <Form.Group>
                            <Form.Label>Service</Form.Label>
                            <select className="form-control" onChange={(event)=>setServis(event.target.value)}>
                            <option value="any" selected>Any</option>
                            <option value="pppoe">PPPoE</option>
                            <option value="pptp">PPTP</option>
                            <option value="l2tp">L2TP</option>
                            </select>
                        </Form.Group>
                        </div>
                    </div>
                </Form>
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="primary" onClick={simpanSecret}>Simpan</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default Pppsecret;